var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"iconfont icon-empty img",style:({ fontSize: _vm.size + 'px' })}),_c('div',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }